import { apiContractRequest } from "./client";

function buildImportFormData(file) {
  const formData = new FormData();
  formData.append("sourceType", "upload");
  formData.append("file", file);
  return formData;
}

/**
 * Cliente aislado del importador Owner.
 *
 * Deliberadamente NO cuelga de ownerApi: el importador es una feature de carga
 * de archivos con ciclo preview -> commit y debe poder evolucionar sin quedar
 * acoplado al objeto API general del Centro Owner.
 */
export const ownerFinanceImportApi = Object.freeze({
  create(file) {
    if (!file) {
      throw new TypeError("Seleccioná un archivo antes de continuar.");
    }

    return apiContractRequest("/api/owner/finance/imports", {
      method: "POST",
      body: buildImportFormData(file),
    });
  },

  preview(importId) {
    const id = String(importId || "").trim();
    if (!id) throw new TypeError("La importación no tiene un identificador válido.");

    return apiContractRequest(`/api/owner/finance/imports/${encodeURIComponent(id)}/preview`, {
      method: "POST",
      body: {},
    });
  },

  commit(importId) {
    const id = String(importId || "").trim();
    if (!id) throw new TypeError("La importación no tiene un identificador válido.");

    return apiContractRequest(`/api/owner/finance/imports/${encodeURIComponent(id)}/commit`, {
      method: "POST",
      body: {},
    });
  },
});
